// Junais 08-Dec-2022
import React from 'react'
import Modal from 'react-modal'

/*
1.  prop modalType is added for componenets... pass componenet in modalType value
    for normal message boxes don't pass this prop at all...

*/
export default function CustomModal(props) {
    let zindexOverly = props.zIndex ? props.zIndex : 10000000;
    let customStyles = !props.modalType ? {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: zindexOverly,
            backgroundColor: 'rgba(225, 225, 225, 0.547)'
        },
        content: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            width: '900px',
            height: '600px',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    } : {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: zindexOverly,
            backgroundColor: 'rgba(225, 225, 225, 0.547)',

        },
        content: {
            position: 'absolute',
            padding: 0,
            border: '0px solid',
            height: '90vh',
            overflow: 'auto',
            background: '#fefefe',
            boxShadow: '0 0 5pt #85878a !important',
        },
    }
    if (props.modalType == "smallComponent") {
        customStyles = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: zindexOverly,
                backgroundColor: 'rgba(225, 225, 225, 0.547)',

            },
            content: {
                position: 'absolute',
                padding: 0,
                border: '0px solid',
                top: '50%',
                left: '50%',
                width: '900px',
                height: '800px',
                overflow: 'auto',
                background: '#fefefe',
                boxShadow: '0 0 5pt #85878a !important',
                transform: 'translate(-50%, -50%)'
            },
        }
    }
    function handleRequestClose() {
        if (props.onRequestClose) {
            props.onRequestClose();
        }
    }

    return (
        <div>
            <Modal
                isOpen={props.isOpen}
                style={customStyles}
                // overlayClassName="overlay"
                contentLabel="onRequestClose Example"
                onRequestClose={handleRequestClose}
            >
                {!props.modalType && <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="modal-title">
                                <span class="badge badge-primary-lighten"><i className="dripicons-information"></i>  {props.headerTitle}</span></h3>
                        </div>
                        <div class="modal-body " >
                            {props.children}
                        </div>
                    </div>
                </div>}
                {props.modalType && <div class="modal-body " >
                    {props.children}
                </div>
                }
            </Modal>
        </div>

    );
}
// {props.modalType && <div class="modal-dialog modal-full-width"  >

// <div class="modal-content">
// <div class="modal-body" style={{padding:'0 0 0 0 !important'}}>
//     {props.children}
//     </div>
// </div>
// </div>}

/*
export default function CustomModal(props) {

    const customStyles = {
        content: {
            zindex: 10000000,
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    function handleRequestClose(){
        if(props.onRequestClose){
           props.onRequestClose();
        }
    }

    return (
        <div>
            <Modal
                isOpen={props.isOpen}
                style={customStyles}
                overlayClassName="overlay"
                contentLabel="onRequestClose Example"
                onRequestClose={handleRequestClose}
            >

                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Messages</h5>
                        </div>

                        {props.children}

                    </div>
                </div>
            </Modal>
        </div>

    );
}
*/